"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderSelect = void 0;
var react_1 = __importDefault(require("react"));
var react_device_detect_1 = require("react-device-detect");
var constants_1 = require("../constants");
var ProviderSelect = function (_a) {
    var provider = _a.provider, onClick = _a.onClick;
    var title = (react_1.default.createElement("div", { className: "tw-pb-1 tw-font-medium dark:tw-text-gray-300" }, provider.canConnect() ? provider.name : "Install " + provider.name));
    if (react_device_detect_1.isMobile && provider.name === constants_1.SupportedProviders.MetaMask) {
        title = (react_1.default.createElement("div", { className: "tw-pb-1 tw-font-medium dark:tw-text-gray-300" }, provider.canConnect() ? provider.name : "Open " + provider.name));
    }
    return (react_1.default.createElement("button", { className: "tw-flex tw-flex-row tw-items-center tw-text-left tw-py-4 tw-pl-3 tw-pr-2 tw-w-80 md:tw-w-96 hover:tw-bg-gray-100 dark:hover:tw-bg-gray-700 tw-transition tw-rounded-md  focus:tw-outline-none", onClick: provider.canConnect()
            ? onClick
            : provider.installURL
                ? function () {
                    return window.open(provider.installURL, '_blank', 'noopener,noreferrer');
                }
                : undefined },
        react_1.default.createElement("div", { className: "tw-flex tw-flex-shrink-0 tw-mr-4 md:tw-mr-5 " },
            react_1.default.createElement("span", { className: "tw-my-auto" }, typeof provider.icon === 'string' ? (react_1.default.createElement("img", { src: provider.icon, alt: provider.name + " logo", style: { height: '42px', width: '42px' } })) : (react_1.default.createElement(provider.icon, { style: { height: '42px', width: '42px' } })))),
        react_1.default.createElement("div", null,
            title,
            react_1.default.createElement("div", { className: "tw-text-sm tw-text-gray-600 dark:tw-text-gray-400" }, provider.description))));
};
exports.ProviderSelect = ProviderSelect;
//# sourceMappingURL=ProviderSelect.js.map